import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Modal, ModalHeader, ModalFooter, Button } from "reactstrap";
import { logoutUser } from "~/redux/actions";

const HierarkiNotFound = () => {
  const { desa } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();

  return (
    <Modal isOpen toogle={() => dispatch(logoutUser())} centered>
      <ModalHeader>
        Hierarki di desa {desa?.nama_desa} belum terdaftar ! Silahkan minta
        admin kabupaten untuk menambahkannya
      </ModalHeader>
      <ModalFooter>
        <Button color="danger" onClick={() => dispatch(logoutUser())}>
          Keluar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default HierarkiNotFound;
